import React from 'react';

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark-card border-t border-dark-border py-8" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center">
          <nav className="mb-4" aria-label="Footer navigation">
            <ul className="flex space-x-6">
              <li>
                <a 
                  href="#features" 
                  className="text-dark-muted hover:text-dark-text transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a 
                  href="#pricing" 
                  className="text-dark-muted hover:text-dark-text transition-colors"
                >
                  Pricing
                </a>
              </li>
              <li>
                <span className="text-dark-muted">
                  contact.payoai@gmail.com
                </span>
              </li>
            </ul>
          </nav>
          <p className="text-sm text-dark-muted">
            <span aria-label={`Copyright ${currentYear}`}>
              © {currentYear}
            </span>
            {' '}
            <span>Payo AI. All rights reserved.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}